import './BattleMenu.css';
import {useState} from "react";
import GiveUp from "./GiveUp";
import MusicBattleButton from "./MusicBattleButton";

function BattleMenu() {

    const [menuOpen, setMenuOpen] = useState(false);

    let rootClass = 'battleMenuClosed';

    if (menuOpen) {
        rootClass = 'battleMenuOpen';
    }

    const toggleMenu = () => {
        if (menuOpen) {
            setMenuOpen(false);
        } else {
            setMenuOpen(true);
        }
    }

    return <div className={rootClass}>
        <div className={'battleMenuButton'}
             onClick={() => {
                 toggleMenu();
             }}
        ></div>

        {menuOpen
            ? <GiveUp />
            : <div></div>
        }

        {menuOpen
            ? <MusicBattleButton />
            : <div></div>
        }

    </div>

}

export default BattleMenu